<section>
  <article style="background-color: #081522">
    <div class="container-fluid">
      <div class="container df resp_remove_padding">
        <div class="vertical_page mrAuto df">
          <div class="container_form">
            <div class="headerTxt"><span
              class="htext"><b>VIEW DEVICE(S) DETAILS UNDER SDT</b></span></div>
            <div class="pd20">
              <div class="df">
                <form [formGroup]="dateForm" class="resp_DF">
                  <mat-form-field appearance="outline" class="mr10">
                    <mat-label><b>SDT From Date</b></mat-label>
                    <input matInput [matDatepicker]="datepicker1" [(ngModel)]="viewdevices.sdtStartDate"
                      formControlName="sdtStartDate" class="bgTrans" [disabled]="true">
                    <mat-hint>MM-DD-YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="datepicker1" [disabled]="true"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker1 [disabled]="true">
                      <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="mr10">
                    <mat-label><b>SDT To Date</b></mat-label>
                    <input matInput [matDatepicker]="datepicker" [(ngModel)]="viewdevices.sdtEndDate"
                      (dateChange)="onDateChange($event)" [min]="ToDateMaxDate" formControlName="sdtEndDate"
                      class="bgTrans"
                      [ngClass]="{'normalColor':editClicked,'cngColor':!editClicked}" [disabled]="this.editClicked">
                    <mat-hint>MM-DD-YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker>
                      <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </form>
                <i class='fas fa-edit editIcon' *ngIf="hideIcon()" (click)='edit()'></i>
              </div>

            </div>
            <div class="pd20 osc175" style="padding: 0px 10px;">
              <table class="table table-borderless" style="width: 100%;">
                <thead>
                  <th class="tblCol">DEVICE NAME</th>
                  <th class="tblCol" [(ngModel)]="selectedOption">REASON <span *ngIf="!editClicked" (click)="toggleDialog()"><i class='fas fa-edit'></i></span></th>
                  <th class="tblCol" *ngIf="hideIcon()">ACTION</th>
                </thead>
                <tbody>
                  <tr *ngFor="let data of deviceData; let i = index;">
                    <td class="txtctr" [ngClass]="{'selectRow': data.selected}">{{data.deviceName}}</td>
                    <td class="txtctr" [ngClass]="{'selectRow': data.selected}" *ngIf="!reasonChanged">{{data.reason}}</td>
                    <td class="txtctr" [ngClass]="{'selectRow': data.selected}" *ngIf="reasonChanged && sdtReason !=='Other'">{{sdtReason}}</td>
                    <td class="txtctr" [ngClass]="{'selectRow': data.selected}" *ngIf="reasonChanged && sdtReason =='Other'">{{otherReason}}</td>
                    <td style="text-align: right;" [ngClass]="{'selectRow': data.selected}"><i class="material-icons img_delete"
                        [ngClass]="{'normalColor':editClicked,'cngColor':!editClicked}"
                        (click)="delete(data,i);" *ngIf="hideIcon()">delete</i></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="showDialog" class="dialog-overlay" (click)="toggleDialog()">
              <div class="dialog-content" (click)="$event.stopPropagation()">
                <form [formGroup]="reasonForm">
                  <mat-form-field appearance="outline" class="outline form-field"> 
                    <mat-select formControlName="sdtReason" placeholder="Choose a Reason" (selectionChange)="changeReason($event)" class="select-reason">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let reasn of reasonsList" [value]="reasn">{{ reasn }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="reasonTag === 'other_scheduled_downtime_reason'" class="other-reason-container">
                    <mat-form-field class="df other-reason-field" floatLabel="never" appearance="outline" hintLabel="Max 40 characters">
                      <textarea matInput #txtarea formControlName="otherReason" maxlength="40" spellcheck="false" placeholder="Other Reason *" class="otherReasonInput">
                      </textarea>
                      <mat-error *ngIf="reasonForm.get('otherReason').invalid">Please Enter a Reason</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="buttons-container">
                    <span class="button-wrap"><button (click)="closeDialog()" class="cancel-button">CANCEL</button></span>
                    <span class="button-wrap"><button (click)="confirmSelection()" [disabled]="sdtReason === 'Select' || !sdtReason" class="select-button">SELECT</button></span>
                  </div>  
                </form>
              </div>
            </div>
            <div class="txtctr">
              <div class="newCreated">
                <span class="createUpdte"
                  class="headingSpan bold">CREATED BY</span>
                <div class="new1">

                  <span
                    class="createBy">{{allDevices[0]?.createdBy}}</span>
                  <br> <span class="createBy">
                    {{allDevices[0]?.createdAt}} UTC</span><br>


                </div>

              </div>
              <div class="newCreated">
                <span class="createUpdte"
                  class="headingSpan bold">UPDATED BY</span>
                <div class="new1">
                  <span
                    class="createBy">{{viewdevices.updatedBy}}</span>
                  <br>
                  <span
                    class="createBy">{{viewdevices.updatedAt}}
                    UTC</span>

                </div>
              </div>
              <hr>

            </div>

            <div class="pd20" style="padding-top: 0px;">
              <div class="submit_button">
                <div class="display_flex">
                  <button class="fancy-button medium sun vertical" (click)="cancel()">
                    Cancel
                    <span class="icon">
                      <i class="fa fa-arrow-circle-down"></i>
                    </span>
                  </button>
                  <button class="fancy-button medium sun vertical" (click)="updateData()" [disabled]="!updateReady" *ngIf="hideIcon()">
                    Update
                    <span class="icon">
                      <i class="fa fa-arrow-circle-up"></i>
                    </span>
                  </button>
                  <button class="fancy-button medium sun vertical" [disabled]="!isDataReady">
                    <a href="{{zenurl}}" target="_blank" style="color: inherit; text-decoration: none;">View Ticket</a>
                  </button>
                </div>

              </div>
            </div>
            <div class="w-100 t-history" style="padding-bottom: 50px;">
              <mat-form-field appearance="outline" class="outline">
                <mat-select [(ngModel)]="thistory" placeholder="Ticket History" class="txtctr" (selectionChange)="getTicketHistory()">
                  <mat-option>Ticket History
                  </mat-option>
                  <mat-option *ngFor="let data of deviceData; let i = index;" [value]="data.uqId">{{data?.deviceName}}
                  </mat-option>
                </mat-select>
                <mat-error>Please Choose</mat-error>
              </mat-form-field>
              <table class="table table-border" style="width: 100%;" *ngIf="thistory">
                <thead>
                  <th class="tblCol">DEVICE NAME</th>
                  <th class="tblCol">TICKET ID</th>
                  <th class="tblCol">TICKET URL</th>                  
                  <th class="tblCol">CREATED DATE</th>
                  <th class="tblCol">STATUS</th>
                </thead>
                <tbody>
                  <tr *ngFor="let data of thistorydata; let i = index;">
                    <td class="txtctr">{{data?.deviceName}}</td>
                    <td class="txtctr">{{data?.ticketId}}</td>
                    <td class="txtctr">
                      <a [attr.href]="getFormattedTicketUrl(data.ticketUrl)" class="ticketUrl" target="_blank">
                        Click Here
                      </a>
                    </td>
                    <td class="txtctr">{{data?.createdDate}}</td>
                    <td class="txtctr">{{data?.ticketStatus}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>